<template>
    <div class="example-profiles">

    </div>
</template>
<style>

</style>
<script>
    import page from '../pages/page';

    export default {
        mixins: [page],
        props: {
            changedProperty: String
        },
        watch: {
            changedProperty: function(property) {
                console.log(`${property} changed`);
            }
        },
        data(){
            return{
                quotes: require('../../assets/data/quotes.json')
            }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// example-profiles.vue?7b7d2ad0